import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter } from "@/lib/types";
import type { ReactNode } from "react";

interface MatterLitigationDateContextMenuProps {
  canDelete: boolean;
  completed?: string | null;
  deadline?: string | null;
  description?: string | null;
  id: string;
  isDeleting: boolean;
  label: string;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  trigger: ReactNode;
}

export const MatterLitigationDateContextMenu = ({
  canDelete,
  completed,
  deadline,
  description,
  id,
  isDeleting,
  label,
  matter,
  onDelete,
  onEdit,
  trigger,
}: MatterLitigationDateContextMenuProps) => {
  const entityLabel = label || "litigation date";

  return (
    <MatterSubItemContextMenu
      copyValue={[
        entityLabel,
        deadline ? `Deadline: ${deadline}` : undefined,
        completed ? `Completed: ${completed}` : undefined,
        description ? `Description: ${description}` : undefined,
      ]
        .filter(Boolean)
        .join("\n")}
      delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
      entityLabel={entityLabel}
      entityName="litigation date"
      matter={matter}
      onEdit={onEdit}
      subItem={{ id, type: "matter-litigation-date" }}
      trigger={trigger}
    />
  );
};
